import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const CRSForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = "#C62828"; // UMS red

  const aePano = config.aePanoSettings || {};

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      {/* <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        CR Simplified Configuration
      </Typography> */}

      {/* --- Top-Level Fields --- */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="Auction Code"
            fullWidth
            value={config.auctionCode || ""}
            onChange={(e) => onChange("auctionCode", e.target.value)}
            variant="outlined"
            InputLabelProps={{ style: { color: "#aaa" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
              "& .MuiInputBase-input": { color: "#fff" },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.isPostRecon ?? false}
                onChange={(e) => onChange("isPostRecon", e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={<Typography sx={{ fontWeight: 500 }}>Post Recon</Typography>}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.stockNumbers ?? false}
                onChange={(e) => onChange("stockNumbers", e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={<Typography sx={{ fontWeight: 500 }}>Stock Numbers</Typography>}
          />
        </Grid>
      </Grid>

      {/* --- aePanoSettings Nested Section --- */}
      <Box
        sx={{
          mt: 3,
          pl: 2,
          pt: 2,
          borderLeft: `2px solid ${red}`,
          backgroundColor: "rgba(198,40,40,0.05)",
          borderRadius: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            mb: 1,
            fontWeight: 600,
            color: red,
          }}
        >
          AE Pano Settings
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={aePano.aePano ?? false}
                  onChange={(e) =>
                    onChange("aePanoSettings.aePano", e.target.checked)
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: red,
                    },
                  }}
                />
              }
              label={<Typography sx={{ fontWeight: 500 }}>AE Pano</Typography>}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={aePano.allowLocalReconCalculation ?? false}
                  onChange={(e) =>
                    onChange(
                      "aePanoSettings.allowLocalReconCalculation",
                      e.target.checked
                    )
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: red,
                    },
                  }}
                />
              }
              label={
                <Typography sx={{ fontWeight: 500 }}>
                  Allow Local Recon Calculation
                </Typography>
              }
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="API URL"
              fullWidth
              value={aePano.apiUrl || ""}
              onChange={(e) =>
                onChange("aePanoSettings.apiUrl", e.target.value)
              }
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#444" },
                  "&:hover fieldset": { borderColor: red },
                  "&.Mui-focused fieldset": { borderColor: red },
                },
                "& .MuiInputBase-input": { color: "#fff" },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Auction Code"
              fullWidth
              value={aePano.auctionCode || ""}
              onChange={(e) =>
                onChange("aePanoSettings.auctionCode", e.target.value)
              }
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#444" },
                  "&:hover fieldset": { borderColor: red },
                  "&.Mui-focused fieldset": { borderColor: red },
                },
                "& .MuiInputBase-input": { color: "#fff" },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Encoding"
              fullWidth
              value={aePano.encoding || ""}
              onChange={(e) =>
                onChange("aePanoSettings.encoding", e.target.value)
              }
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#444" },
                  "&:hover fieldset": { borderColor: red },
                  "&.Mui-focused fieldset": { borderColor: red },
                },
                "& .MuiInputBase-input": { color: "#fff" },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Pano Code"
              fullWidth
              value={aePano.panoCode || ""}
              onChange={(e) =>
                onChange("aePanoSettings.panoCode", e.target.value)
              }
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#444" },
                  "&:hover fieldset": { borderColor: red },
                  "&.Mui-focused fieldset": { borderColor: red },
                },
                "& .MuiInputBase-input": { color: "#fff" },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={aePano.postRecon ?? false}
                  onChange={(e) =>
                    onChange("aePanoSettings.postRecon", e.target.checked)
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: red,
                    },
                  }}
                />
              }
              label={<Typography sx={{ fontWeight: 500 }}>Post Recon</Typography>}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CRSForm;
